export enum TitleType {
    Owner = 'Owner',
    Office = 'Office',
    Member = 'Member'
}